import { useState } from "react";
import { Link2, Unlink } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Modal, primaryBtnCls, ghostBtnCls } from "@/components/Kit";

const LABEL = { hospital: "Hospital", lab: "Laboratory", pharmacy: "Pharmacy" };

export const ModuleLinks = ({ business, onChange }) => {
  const [pending, setPending] = useState(null);
  const [busy, setBusy] = useState(false);
  const modules = business.modules || [];
  const confirm = async () => {
    setBusy(true);
    try {
      await api.post(`/owner/businesses/${business.business_id}/modules`, pending);
      toast.success(pending.linked ? "Module linked. Staff permissions remain unchanged." : "Module unlinked. All historical records are preserved.");
      setPending(null); onChange();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return <div className="mt-4 border-t border-slate-200 pt-4" data-testid={`module-controls-${business.business_id}`}>
    <p className="text-xs font-semibold text-slate-700" data-testid={`linked-modules-${business.business_id}`}>
      {modules.length > 1 ? "Linked modules: " : "Independent: "}{modules.map((m) => LABEL[m]).join(" · ")}
    </p>
    <div className="mt-3 flex flex-wrap gap-2">
      {Object.entries(LABEL).map(([module, label]) => {
        const linked = modules.includes(module); const Icon = linked ? Unlink : Link2;
        return <button type="button" key={module} data-testid={`module-${module}-${business.business_id}`}
          onClick={() => setPending({ module, linked: !linked })}
          disabled={linked && modules.length === 1}
          className="flex items-center gap-1.5 rounded-md border border-slate-300 px-2 py-2 text-xs text-slate-700 hover:border-orange-600 disabled:opacity-40"
          title={`${linked ? "Unlink" : "Link"} ${label}`}>
          <Icon className="h-3.5 w-3.5" /> {linked ? "Unlink" : "Link"} {label}
        </button>;
      })}
    </div>
    <Modal open={!!pending} onClose={() => setPending(null)} title={`${pending?.linked ? "Link" : "Unlink"} ${LABEL[pending?.module] || "module"}?`} testid={`module-confirm-${business.business_id}`}>
      <p className="text-sm text-slate-600 mb-5">{pending?.linked ? "Add this module to the business workspace. This does not grant employees additional permissions." : "Remove this module from the workspace immediately. No patients, bills, prescriptions, orders or reports will be deleted. Linking it again restores access according to RBAC."}</p>
      <div className="flex gap-3"><button type="button" disabled={busy} className={primaryBtnCls} data-testid={`module-confirm-submit-${business.business_id}`} onClick={confirm}>{busy ? "Saving…" : "Confirm"}</button><button type="button" className={ghostBtnCls} data-testid={`module-confirm-cancel-${business.business_id}`} onClick={() => setPending(null)}>Cancel</button></div>
    </Modal>
  </div>;
};
